import styled from 'styled-components';
import { Button, ButtonProps } from 'antd';
import { DISABLED_COLOUR, VIDAPP_GRADIENT } from '../../theme';

interface GradientButtonProps extends ButtonProps {
  $height?: string;
  $width?: string;
  $fontSize?: string;
  $fontWeight?: string;
  $loadingMargin?: string;
}

const UnstyledButton = (props: GradientButtonProps) => {
  return (
    <Button type="primary" shape="round" {...props}>
      {props?.children}
    </Button>
  );
};

const getBackground = (isDisabled?: boolean) => {
  if (isDisabled) {
    return DISABLED_COLOUR;
  }
  // Default background
  return VIDAPP_GRADIENT;
};

export const GradientButton = styled(UnstyledButton)`
  width: ${(props) => props.$width || '100%'};

  &&& {
    height: ${(props) => props.$height || '48px'};
    background: ${(props) => getBackground(props.disabled)};
    border: none !important;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    padding-left: 24px;
    padding-right: 24px;

    > span {
      font-size: ${(props) => props.$fontSize || '16px'};
      font-weight: ${(props) => props.$fontWeight || '500'};
      line-height: 19px;
      color: white;
    }
  ;
  }

  .ant-btn-loading-icon {
    margin-left: ${(props) => (props.$loadingMargin || '8px') + ' !important'};
  }
}
`;
